<template>
  <div id="page" @click="closeQr">
 <!--      <video id="video1" class="margin-custom" width="100%" preload="auto" loop="loop" muted="muted" playsinline>
        <source src="img/video1.mp4" type="video/mp4">
        bgvideo
      </video> -->

 <div class="wrapper">

      <video id="video1" class="margin-custom" width="100%" preload="auto" loop="loop" muted="muted" playsinline>
        <source :src="mobile? 'img/video1_mobile.mp4' : 'img/video1.mp4'" type="video/mp4">
        bgvideo
      </video>
      <transition name="fade">
        <div class="soundon" v-show="soundon" @click="toggleAudio()"></div>
      </transition>
      <transition name="fade">
        <div class="soundoff" v-show="soundoff" @click="toggleAudio()"></div>
      </transition>
  </div>
<!--     <b-carousel
      id="carousel-fade"
      style="text-shadow: 0px 0px 2px #000"
      :interval="8000"
      fade
      img-width="1024"
      img-height="480"
      class="margin-custom carousel-center"
    >
      <b-carousel-slide
        img-src="img/1-Main.jpg">
  
          <h1 class="text_top">FPO</h1>
     </b-carousel-slide>
    </b-carousel> -->
    <div class="bg-black title-padding" id="location">
      <b-container>
        <h3 class="sub-title">A PART OF TORONTO SKYLINE</h3>
    </b-container>
    </div>
 <!-- <div class="wrapper" @click="pauseVideo(1)"> -->
      <video id="video1" class="margin-neg" width="100%" preload="auto" loop="loop" muted="muted" playsinline>
        <source :src="mobile? 'img/Skyline_mobile.mp4' : 'img/Skyline.mp4'" type="video/mp4">
        bgvideo
      </video>
      <!-- <transition name="fade"> -->
        <!-- <div class="playpause" v-show="paused"></div> -->
      <!-- </transition> -->
  <!-- </div> -->
<!--     <video id="skyline" class="margin-neg" width="100%" preload="auto" loop="loop" muted="muted" playsinline>
        <source src="img/Skyline.mp4" type="video/mp4">
        bgvideo
    </video> -->
    <!-- landmark -->
    <div class="bg-black title-padding title-padding-landmark" id="landmark" >
      <b-container>
          <h3 class="sub-title">AN ARCHITECTURAL LANDMARK</h3>
      </b-container>
    </div>
 <!-- <div class="wrapper" @click="pauseVideo(2)"> -->
      <video id="video1" class="margin-neg" width="100%" preload="auto" loop="loop" muted="muted" playsinline>
        <source :src="mobile? 'img/Landmark_mobile.mp4' : 'img/Landmark.mp4'" type="video/mp4">
        bgvideo
      </video>
      <!-- <transition name="fade"> -->
        <!-- <div class="playpause" v-show="paused"></div> -->
      <!-- </transition> -->
  <!-- </div> -->
        <!-- engineering -->
      <div class="bg-black title-padding title-padding-engineering" id="engineering" >
      <b-container>
          <h3 class="sub-title">AN ENGINEERING FEAT</h3>
      </b-container>
      </div>


      
 <!-- <div class="wrapper" @click="pauseVideo(3)"> -->
      <video id="video1" class="margin-neg" width="100%" preload="auto" loop="loop" muted="muted" playsinline>
        <source :src="mobile? 'img/Engineering_mobile.mp4' : 'img/Engineering.mp4'" type="video/mp4">
        bgvideo
      </video>
      <!-- <transition name="fade"> -->
        <!-- <div class="playpause" v-show="paused"></div> -->
      <!-- </transition> -->
  <!-- </div> -->
 
      <div class="bg-black title-padding title-padding-suite" id="suite" >
      <b-container>
          <h3 class="sub-title">PHOTO GALLERY</h3>
      </b-container>
      </div>
<!--       <video id="Majestic" class="margin-neg" width="100%" preload="auto" loop="loop" muted="muted" playsinline >
        <source src="img/Majestic.mp4" type="video/mp4">
        bgvideo
      </video> -->
       <!-- <div class="wrapper" @click="pauseVideo(4)"> -->

      <b-carousel
      id="carousel-fade"
      style="text-shadow: 0px 0px 2px #000"
      :interval="4000"
      controls
      fade
      img-width="1920"
      img-height="920"
      class="carousel-center">
              <span v-for="(img,index) in slideArray" :key="index">
              <a @click.prevent="openModalGallery(index)">
              <b-carousel-slide
                :img-src="img">
              </b-carousel-slide>
              </a>
              </span>
      </b-carousel>
    <b-modal id="modal-gallery" title="" size="xl" hide-footer refs="gallery_modal" v-model="showGallery">
      <p class="pageNum">{{slide+1}} / {{slideArray.length}}</p>
      <span v-for="(img,index) in imageArray" :key="index">
        <transition name="fade" mode="out-in">
          <img   v-if="index == slide" :src="img" alt="" class="img-responsive">
        </transition>
        
      </span>
      <a class="arrow_btn_left" @click.prevent="prevImg()">
         <p :class="mobile ? 'h4' : 'h2'"><b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill></p>
      </a>
      <a  class="arrow_btn_right" @click.prevent="nextImg()">
         <p :class="mobile ? 'h4' : 'h2'"><b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill></p>
      </a>
    </b-modal>
<!--       <video id="video1" class="margin-neg video" width="100%" preload="auto" loop="loop" muted="muted" playsinline>
        <source src="img/Majestic.mp4" type="video/mp4">
        bgvideo
      </video> -->
      <!-- <transition name="fade"> -->
        <!-- <div class="playpause" v-show="paused"></div> -->
      <!-- </transition> -->
  <!-- </div> -->

    <!-- <div class="bg-black title-padding title-padding-virtual wrapper" id="virtual_tour" >
      <b-container>
          <h3 class="sub-title">VIDEO TOUR</h3>
      </b-container>
      <transition name="fade">
        <div class="soundon1" v-show="soundon1" @click="toggleAudioTour()"></div>
      </transition>
      <transition name="fade">
        <div class="soundoff1" v-show="soundoff1" @click="toggleAudioTour()"></div>
      </transition>
    </div>

      <video id="video4" class="margin-neg wrapper" width="100%" preload="auto" loop="loop" muted="muted" playsinline>
          <source :src="mobile? 'img/Virtual_tour_mobile.mp4' : 'img/Virtual_tour.mp4'" type="video/mp4">
          bgvideo
      </video> -->



<!--     <div class="bg-dark title-padding extra-padding" >
      <b-container>
          <h3 class="sub-title" style="color: white;">COMING SOON</h3>
      </b-container>
    </div> -->
    <div class="bg-black title-padding title-padding-view" id="view" >
      <b-container>
          <h3 class="sub-title mb-3">VIEW</h3>
          <button @click="changeView(1)" :class="view1 ? 'activeFloorBtn' : ''" v-scroll-to="'#southview'">South View</button>
          <button @click="changeView(2)" :class="view2 ? 'activeFloorBtn' : ''" v-scroll-to="'#northview'">North View</button>
      </b-container>
    </div>
    

    <video v-show="view1" id="southview" class="margin-neg" width="100%" preload="auto" loop="loop" muted="muted" playsinline >
        <source :src="mobile? 'img/SouthView_mobile.mp4' : 'img/SouthView.mp4'" type="video/mp4">
        bgvideo
    </video>

    <video v-show="view2" id="northview" class="margin-neg" width="100%" preload="auto" loop="loop" muted="muted" playsinline >
        <source :src="mobile? 'img/NorthView_mobile.mp4' : 'img/NorthView.mp4'" type="video/mp4">
        bgvideo
    </video>

      <div class="bg-black title-padding title-padding-floorplan" id="floor_plan" >
      <b-container>
          <h3 class="sub-title mb-3">FLOOR PLAN</h3>
          <!-- <button style="width:220px;" @click="changeSuite(1)" :class="suite2 ? 'activeFloorBtn' : ''" disabled>SUITE 3306 (Sold) </button> -->
          <button style="width:220px;" @click="changeSuite(1)" :class="suite1 ? 'activeFloorBtn' : ''">SUITE 3309</button>
      </b-container>
      </div>
      <FloorplanOne v-show="suite1" ref="childComponent1"></FloorplanOne>
      <FloorplanTwo v-show="suite2" ref="childComponent2"></FloorplanTwo>
         <!-- <b-img src="img/9-Floorplan.jpg" fluid alt="" ></b-img> -->
       <!--  <div class="bg-black title-padding" id="elevation">
        <b-container>
            <h3 class="sub-title">ELEVATION</h3>
        </b-container>
        </div>
 
         <b-img src="img/10-Elevation1.jpg" fluid alt="" class="elevation1"></b-img><br>
         <b-img src="img/Elevation.jpg" fluid alt=""></b-img>

        <div class="bg-black title-padding" id="furniture">
        <b-container>
            <h3 class="sub-title">FURNITURE</h3>
        </b-container>
        </div>

        <div class="furniture">
          <h4 class="sub-title sub-title1">LIVING ROOM</h4>
              <b-img src="img/Livingroom.jpg" fluid alt=""></b-img>
          <h4 class="sub-title">DINING ROOM</h4>
              <b-img src="img/Diningroom.jpg" fluid alt=""></b-img>
          <h4 class="sub-title">MASTER BEDROOM</h4>
              <b-img src="img/Masterbedroom.jpg" fluid alt=""></b-img>
          <h4 class="sub-title">DEN</h4>
              <b-img src="img/Den.jpg" fluid alt=""></b-img>
          <h4 class="sub-title">STUDY</h4>
              <b-img src="img/Study.jpg" fluid alt=""></b-img>
        </div> -->
        <div id="contact" class="bg-black" >
            <b-container class="py-5">
              <h4 class="contact_us">A TEAM OF EXCELLENCE</h4>
                <b-row v-if="mobile_footer">
                 <b-col cols="12" class="text-center mt-4">      
                      <h5><b>ARCHITECT</b></h5>
                          <h5 class="mb-4"><a href="https://www.kpf.com/" target="_blank">KOHN PEDERSEN FOX </a>/ <a href="https://www.ibigroup.com/" target="_blank">IBI GROUP</a></h5>
                      <h5><b>STRUCTURAL ENGINEER</b></h5>
                          <h5 class="mb-4">HALCROW YOLLES</h5>
                      <h5><b>INTERIOR DESIGN</b></h5>
                          <h5 class="mb-4"><a href="https://liv.ca/" target="_blank">LIV DESIGN STUDIO</a></h5>
                 </b-col>
               </b-row>
                <b-row v-else>
                 <b-col cols="6" class="text-right contact_left">      
                      <h5><b>ARCHITECT</b></h5>
                      <h5><b>STRUCTURAL ENGINEER</b></h5>
                      <h5><b>INTERIOR DESIGN</b></h5>
                 </b-col>
                 <b-col cols="6" class="text-left contact_right">
                    <h5><a href="https://www.kpf.com/" target="_blank">KOHN PEDERSEN FOX </a>/ <a href="https://www.ibigroup.com/" target="_blank">IBI GROUP</a></h5>
                    <h5>HALCROW YOLLES</h5>
                    <h5><a href="https://liv.ca/" target="_blank">LIV DESIGN STUDIO</a></h5>
                 </b-col>
               </b-row>
                <h4 class="contact_us mt-cust">INQUIRIES</h4>


                <b-row class="contact_info">
                <b-col class="text-left" md="6" v-if="mobile_footer">
                   <h5 class="ls-cust text-center"><b>SET UP A PRIVATE CONSULTATION OR <br>SCHEDULE A TOUR OF THE BRIDGE SUITES</b></h5>
               </b-col>
               <b-col class="text-right padding-cust contact_left" md="6" v-else>
                   <h5 class="lh-cust"><b>SET UP A PRIVATE CONSULTATION <br>OR SCHEDULE A TOUR OF THE <br> BRIDGE SUITES</b></h5>
                </b-col>
          <!-- <form class="" action=""> -->
                  <b-col md="6" class="ml-cust contact_right">
                    <form class="" @submit.prevent >
                      <b-row class="mb-2 text-left"><b-col cols="6" md="6" lg="5" xl="4"><label for="firstname">FIRST NAME:</label></b-col>
                      <b-col>
                        <input type="text" id="firstname" v-model="details.firstname">
                        <p class="contact_warning" v-show="firstname_error">The FIRST NAME field is required.</p>
                      </b-col>
                    </b-row>

                      <b-row class="mb-2 text-left"><b-col cols="6" md="6" lg="5" xl="4"><label for="lastname">LAST NAME:</label></b-col>
                      <b-col>
                        <input type="text" id="lastname" v-model="details.lastname">
                        <p class="contact_warning" v-show="lastname_error">The LAST NAME field is required.</p>
                      </b-col>
                      </b-row>

                      <b-row class="mb-2 text-left"><b-col cols="6" md="6" lg="5" xl="4"><label for="email">EMAIL ADDRESS:</label></b-col>
                        <b-col>
                          <input type="email" id="email" v-model="details.email">
                          <p class="contact_warning" v-show="email_error">The EMAIL ADDRESS field is required.</p>
                        </b-col>
                      </b-row>

                      <b-row class="mb-2 text-left"><b-col cols="6" md="6" lg="5" xl="4"><label for="phone">PHONE NUMBER:</label></b-col>
                        <b-col>
                          <input type="tel" id="phone" v-model="details.phone">
                          <p class="contact_warning" v-show="phone_error">The PHONE NUMBER field is required.</p>
                        </b-col>
                      </b-row>

                      <b-row class="mt-3 submit_btn">
                          <b-col class="submit_left" cols="5" md="6" lg="5" xl="4"></b-col>
                          <b-col class="submit">
                            <input type="submit" value="SUBMIT" @click="submitForm()">
                          </b-col>
                      </b-row>
                       </form>
                  </b-col>
                </b-row>
                <b-row class="contact_info mt-5">
                 <b-col md="6" :class="mobile_footer ? 'text-center' : 'text-right'" class="padding-cust">      
                      <h5 class="ls-cust contact_left"><b>PROMPTON REAL ESTATE SERVICES</b></h5>
                 </b-col>
                 <b-col md="6" :class="mobile_footer ? 'text-center' : 'text-left'" class="contact_right">
                    <h5>JENNY DONG | BROKER</h5>
                    <h5>MOBILE: <span :class="mobile_footer ? '' : 'ml-2'">647-927-8888</span></h5>
                    <h5>EMAIL: <span :class="mobile_footer ? '' : 'ml-4'">jdong@prompton.ca</span></h5>
                 </b-col>
               </b-row>
               <b-row class="contact_info mt-5">
                <b-col md="6" :class="mobile_footer ? 'text-center' : 'text-right'" class="padding-cust">      
                     <!-- <h5 class="ls-cust contact_left"><b>PROMPTON REAL ESTATE SERVICES</b></h5> -->
                </b-col>
                <b-col md="6" :class="mobile_footer ? 'text-center' : 'text-left'" class="contact_right">
                   <h5>RAUL ARAGON | SALES REPRESENTATIVE</h5>
                   <h5>MOBILE: <span :class="mobile_footer ? '' : 'ml-2'">416-746-7285</span></h5>
                   <h5>EMAIL: <span :class="mobile_footer ? '' : 'ml-4'">raragon@prompton.ca</span></h5>
                </b-col>
              </b-row>
              </b-container>
              <hr>
              <b-container class="contact_address" id="contact">
              <b-row class="address_row">
                <b-col md="2" lg="3" cols="5" class="footer_logo padding-cust">
                    <b-img src="img/concord-logo.png" fluid alt="" ></b-img>
                </b-col>
                <b-col  md="8" lg="7" cols="12" class="footer_address">
                    <h5 class="address">88 QUEENS WHARF ROAD, TORONTO, ON, M5V0P2</h5><h5 class="contact_number">416-813-0999</h5>
                </b-col>
                <b-col class="footer_icon">
                    <b-row class="social-icons">
                       <a href="https://www.facebook.com/ConcordAdex/"><b-img src="img/fb.png" fluid alt="" class="mr-2"></b-img></a>
                       <a href="https://ca.linkedin.com/company/concord-adex-inc"><b-img src="img/in.png" fluid alt="" class="mr-2"></b-img></a>
                       <b-img src="img/wx.png" fluid alt="" class="mr-2 wx" id="tooltip-button"></b-img>
                      <b-tooltip ref="tooltip" target="tooltip-button" triggers="click">
                          <img src="img/qr-code.jpg" style="width:100px;">
                      </b-tooltip>
                       <a href="https://www.youtube.com/user/ConcordPacificDevInc"><b-img src="img/yt.png" fluid alt="" class="mr-2"></b-img></a>
                    </b-row>
                </b-col>
              </b-row>
            </b-container>
      
        <p class="text-white nm-p footer">© {{year}} Concord CityPlace | All rights reserved.</p>
        </div>


  <b-modal id="modal-lg" size="xl" title="videos" hide-footer>      
    <b-carousel
      id="carousel-fade"
      style="text-shadow: 0px 0px 2px #000"
      :interval="8000"
      img-width="1024"
      img-height="480"
    >
      <b-carousel-slide class="p-5"
        img-src="img/2-Location.jpg" width="500px"
      ></b-carousel-slide>
    </b-carousel>
    <p class="text-center">Located  on  a bridge  suspended in  mid air by  
    two high  rises,  Bridge  Suites  is  the crown 
    feature of  a unique  architectural landmark. Truly one-of-a-kind,  one of  the most  
    attention-commanding  and prestigeous
    penthouses  in  Toronto.
    </p>
  </b-modal>
  <div id="myModal" class="modal" v-show="showModal">

  <!-- Modal content -->
  <div class="modal-content" >
    <span class="close" @click="closeModal()">&times;</span>
    <p>Thank you for your inquiry.</p>
    <p>Our agent will be in touch with you soon.</p>
  </div>

</div>
  </div>
</template>

<script>

import FloorplanOne from './FloorplanOne.vue';
import FloorplanTwo from './FloorplanTwo.vue';
export default {
  name: 'Location',
  components:{
    FloorplanOne,
    FloorplanTwo
  },
  data(){
    return {
      year: '',
      videos: '',
      fraction: 0.6,
      mobile: false,
      suite1:true,
      suite2:false,
      view1:true,
      view2:false,
      paused:true,
      mobile_footer:false,
      soundon:false,
      soundoff:true,
      soundon1:false,
      soundoff1:true,
      details:{
        firstname:'',
        lastname:'',
        email:'',
        phone:''
      },
      firstname_error:false,
      lastname_error:false,
      email_error:false,
      phone_error:false,
      showModal: false,
      slide:0,
      showGallery:false,
      slideArray:[
        'img/3309/gallery/Bar-bridgesuite.jpg', 
        'img/3309/gallery/Ensuite-bridgesuite.jpg', 
        'img/3309/gallery/Bedroom01-bridgesuite.jpg', 
        'img/3309/gallery/Closet-bridgesuite.jpg', 
        'img/3309/gallery/Living01-bridgesuite.jpg', 
        'img/3309/gallery/Living02-bridgesuite.jpg', 
        'img/3309/gallery/Living03-bridgesuite.jpg', 
        'img/3309/gallery/Kitchen-bridgesuite.jpg', 
        'img/3309/gallery/Dining-bridgesuite.jpg', 
        'img/3309/gallery/MasterBedroom01-bridgesuite.jpg', 
        'img/3309/gallery/Stairs-bridgesuite.jpg', 
        'img/3309/gallery/Terrace final V1 B-crop.jpg', 
        'img/3309/gallery/Garage-bridgesuite.jpg', 
      ],
      imageArray:[
        'img/3309/gallery/Bar-bridgesuite.jpg', 
        'img/3309/gallery/Ensuite-bridgesuite.jpg', 
        'img/3309/gallery/Bedroom01-bridgesuite.jpg', 
        'img/3309/gallery/Closet-bridgesuite.jpg', 
        'img/3309/gallery/Living01-bridgesuite.jpg', 
        'img/3309/gallery/Living02-bridgesuite.jpg', 
        'img/3309/gallery/Living03-bridgesuite.jpg', 
        'img/3309/gallery/Kitchen-bridgesuite.jpg', 
        'img/3309/gallery/Dining-bridgesuite.jpg', 
        'img/3309/gallery/MasterBedroom01-bridgesuite.jpg',
        'img/3309/gallery/Stairs-bridgesuite.jpg', 
        'img/3309/gallery/Terrace final V1 B-crop.jpg',
        'img/3309/gallery/Garage-bridgesuite.jpg', 
      ],
      
    }
  },
  mounted(){
   
    if(window.innerWidth <= 767){
        this.mobile_footer = true;
    }else{
        this.mobile_footer = false;
    } 
    if (window.innerWidth < 500) {
        this.mobile = true;
    } else {
        this.mobile = false;
    }
    this.year = new Date().getFullYear();
    this.videos = document.getElementsByTagName("video");
    this.videos[0].play();
    window.addEventListener('scroll', this.checkScroll, false);
    window.addEventListener('resize', this.checkScroll, false);
    if(window.innerWidth < 500){
       this.mobile = true;
       this.videos[1].play();
    }else{
       this.mobile = false;
    }
  },
  computed:{
     arrayLength(){
        return this.slideArray.length;
     }
  },
  methods:{
    nextImg(){
        this.slide++;
        if(this.slide == this.arrayLength) this.slide = 0;
    },
    prevImg(){
        this.slide--;
        if(this.slide == -1 ) this.slide = (this.arrayLength - 1);
    },
    openModalGallery(id){
      this.showGallery = true;
      this.slide = id;
    },
    openModal(){

        this.showModal = true;
        this.details.firstname = "";
        this.details.lastname = "";
        this.details.email = "";
        this.details.phone = "";
        setTimeout(() => this.showModal = false, 3000);
    },
    closeModal(){
        this.showModal = false;
    },
    submitForm(){   

      if(this.details.firstname == ""){
          this.firstname_error = true;
      }else{
        this.firstname_error = false;
      }
      if(this.details.lastname == ""){
          this.lastname_error = true;
      }else{
        this.lastname_error = false;
      }
      if(this.details.email ==""){
          this.email_error = true;
      }else{
        this.email_error = false;
      }
      if(this.details.phone ==""){
          this.phone_error = true;
      }else{
        this.phone_error = false;
      }
      if(this.details.firstname != "" && this.details.lastname != "" && this.details.email !="" &&this.details.phone != ""){
          this.$http.post('/send.php',JSON.stringify({
              'firstname':this.details.firstname,
              'lastname':this.details.lastname,
              'email':this.details.email,
              'phone':this.details.phone
          })).then((response)=>{
            console.log(response.data.trim());
              if(response.data.trim() == "added"){
               
                        this.showModal = true;
                        this.details.firstname = "";
                        this.details.lastname = "";
                        this.details.email = "";
                        this.details.phone = "";
                        setTimeout(() => this.showModal = false, 3000);
              }

                        });
        }

    },
    toggleAudio(){
      // this.paused = !this.paused;
      if(this.videos[0].muted){
        this.videos[0].muted = false;
        this.soundon = true;
        this.soundoff = false;
      }else{
        this.videos[0].muted = true;
        this.soundon = false;
        this.soundoff = true;
      }
    },
    toggleAudioTour(){
      if(this.videos[4].muted){
        this.videos[4].muted = false;
        this.soundon1 = true;
        this.soundoff1 = false;
      }else{
        this.videos[4].muted = true;
        this.soundon1 = false;
        this.soundoff1 = true;
      }
    },
    closeQr(){
      this.$refs.tooltip.$emit('close');
    },
    pauseVideo(n){
      this.paused = !this.paused;
      if(this.videos[n].paused){
        this.videos[n].play();
      }else{
        this.videos[n].pause();
      }
    },
    changeSuite(n){
      if(n == 1){
         this.$refs.childComponent1.resetComp();
         this.suite1 = true;
         this.suite2 = false;
      }else{
         this.$refs.childComponent2.resetComp();
         this.suite1 = false;
         this.suite2 = true;
      }
    },
    changeView(n){
      if(n == 1){
         this.view1 = true;
         this.view2 = false;
      }else{
         this.view1 = false;
         this.view2 = true;
      }
    },
    checkScroll() {
    for(var i = 0; i < this.videos.length; i++) {

        var video = this.videos[i];

        var x = video.offsetLeft, y = video.offsetTop, w = video.offsetWidth, h = video.offsetHeight, r = x + w, //right
            b = y + h, //bottom
            visibleX, visibleY, visible;

            visibleX = Math.max(0, Math.min(w, window.pageXOffset + window.innerWidth - x, r - window.pageXOffset));
            visibleY = Math.max(0, Math.min(h, window.pageYOffset + window.innerHeight - y, b - window.pageYOffset));

            visible = visibleX * visibleY / (w * h);

            if (visible > this.fraction) {
                video.play();
            } else {
                video.pause();
            }

      }

    },
    onResize() {
    if(window.innerWidth <= 767){
        this.mobile_footer = true;
    }else{
        this.mobile_footer = false;
    } 
    if (window.innerWidth < 500) {
        this.mobile = true;
    } else {
        this.mobile = false;
      }
    },
  },
  created() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
}
</script>
<style>
  .modal-xl{
    max-width: 100vw !important;
  }
  #modal-gallery{
    padding:0 !important;
  }
  #modal-gallery .modal-dialog{
    max-width: 100%;
    margin: 0 !important;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
}
 #modal-gallery .modal-body{
   display: flex;
   justify-content: center;
   align-items: center;
 }
 #modal-gallery .pageNum{
    position: absolute;
    top: -35px;
    left: 15px;
    color: white;
 }
</style>
<style scoped>
  .fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease-in;
}
.fade-enter,.fade-leave-to{
  opacity: 0;
}
  .arrow_btn_left{
    position: absolute;
    left: 2%;
  }
  .arrow_btn_left:hover{
    cursor: pointer;
  }
  .arrow_btn_right{
    position: absolute;
    right: 2%;
  }
  .arrow_btn_right:hover{
    cursor: pointer;
  }
  .img-responsive{
        max-height: 90%;
        max-width: 80%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
  }
  .modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 400px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
 background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #a4842d;
  margin: auto;
  padding: 5px 20px;
  border: 1px solid #888;
  width: 25%;
}
.btn{
  padding:  0;
  margin: 0;
  border:0;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  margin-left: auto;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
@media (max-width: 500px){
    .modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 200px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
 background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}
  .modal-content {
    background-color: #a4842d;
    margin: auto;
    padding: 5px 20px;
    border: 1px solid #888;
    width: 90%;
    color: white;
  }
}
</style>
<style>
  .modal-body{
    color: white;
  }
  .modal-content{
    border: none !important;
  }
  .btn-success{
    background-color: #a4842d !important;
    border:none !important;
  }
  .btn-success:hover{
      background-color:  #a4842d !important;
    }
  .modal-footer{
    background-color: #000 !important;
}
.carousel-control-prev-icon, .carousel-control-next-icon{
  width: 40px !important;
  height: 40px !important;
}
.tooltip-inner{
  background-color: transparent !important;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease-in;
}
.fade-enter,.fade-leave-to{
  opacity: 0;
}
.wrapper{

    position:relative;
  
}
.soundon {
    background-image:url('/img/soundon.png');
    background-repeat:no-repeat;
    width:50%;
    height:50%;
    position:absolute;
    right:3%;
    top:-3%;
    width: 25px;
    background-size:contain;
    background-position: center;
}
.soundon1 {
    background-image:url('/img/soundon.png');
    background-repeat:no-repeat;
    width:50%;
    height:50%;
    position:absolute;
    right:5%;
    top:125%;
    width: 25px;
    background-size:contain;
    background-position: center;
    z-index: 99;
}
.soundon:hover,.soundoff:hover,.soundon1:hover,.soundoff1:hover{
  cursor: pointer;
}
.soundoff {
    background-image:url('/img/soundoff.png');
    background-repeat:no-repeat;
    width:50%;
    height:50%;
    position:absolute;
    right:3%;
    top:-3%;
    width: 25px;
    background-size:contain;
    background-position: center;
}
.soundoff1 {
    background-image:url('/img/soundoff.png');
    background-repeat:no-repeat;
    width:50%;
    height:50%;
    position:absolute;
    right:5%;
    top:125%;
    width: 25px;
    background-size:contain;
    background-position: center;
    z-index: 99;
}

.mt-cust{
   margin-top: 5%;
}
  .margin-neg{
    margin-bottom: -2%;
  }
  .margin-none{
    margin-bottom: 0;
  }
  .carousel-caption h3{
    font-size: 40px;
  }
  .black-caption .carousel-caption h3{
    color: black;
  }
  .sub-title{
    margin-bottom: 0;
  }
  .title-padding{
    padding: 4.5% 0 4.5% 0;
  }
  .title-padding-landmark{
    padding: 5.5% 0 4.5% 0;
  }
  .title-padding-engineering{
    padding: 5.5% 0 4.5% 0;
  }
  .title-padding-suite{
    padding: 5.5% 0 4.5% 0;
  }
  .title-padding-view{
    padding: 3.5% 0 3.5% 0;
  }
  .title-padding-floorplan{
    padding: 4.5% 0 3.5% 0;
  }
  .margin-custom{
    margin-top:6.5%;
    margin-bottom: -1%;
   }
  h1,h2,h3,h4,h5{
    letter-spacing: 5px;
    color: white;
  }
  .sub-title{
    color: inherit;
  }
  .extra-padding h3{
    margin: 20% 0;
  }
  .bg-black{
    background-color: black;
  }
  .bg-black h3{
    color: white;
  }
  .bg-black p{
    color: white;
  }
  .nm-p{
    margin: 0;
    padding-bottom: 2%;
  }
  .carousel-item:hover{
    cursor: pointer;
  }
  .carousel-caption{
   top: 43%;
  }
  .carousel-caption h1{
    font-size: 75px;
  }
  #modal-lg{
    padding: 0 !important;
  }
  .elevation1{
    margin: 3%;
    width: 27%;
  }
  .furniture{
    padding: 3% 0;
  }
  h3.sub-title{
    font-size: 1.5rem;
  }
  h4.sub-title{
    margin: 30px 0;
    font-size: 1.3rem;
  }
  h4.sub-title1{
    margin: 0 0 30px 0;
  }
  #floor_plan button,#view button{
     background-color: #979797;
     border:none;
     color: white;
     width: 150px;
     padding: 1%;
     margin: 0 1%;
   }
  #floor_plan button:hover,#view button:hover{
     background-color: #525151;
   }
  #floor_plan button:focus, #view button:focus{
      outline:none !important;
   }
  .activeFloorBtn{
     background-color: #525151 !important;
   }
   #contact a{
    color: white;
   }
  #contact h5{
    color: white;
    padding: 0.5% 0;
    letter-spacing: 3px;
  }
  #contact .contact_us{
    padding: 1% 0 4% 0;
  }
  #contact .contact_info{
    justify-content: center;
  }
  #contact h4{
    letter-spacing: 5px;
  }
  #contact .behind_scene{
    padding-bottom: 4%;
  }
  #contact hr{
    margin: 1% auto 5% auto;
    border: none;
    background-color: white;
    height: 0.5px;
    /*width: 70%;*/
  }
  #contact h4{
    font-size: 1.4rem;
  }
  #contact h5{
    font-size: 0.9rem;
  }
  #contact form .col{
    text-align: left;
  }
  #contact label {
     font-size: 0.8rem;
     letter-spacing: 3px;
     color: white;
     margin-bottom: 0.8rem;
     transition: 0.3s ease;
  }
  #contact form input{
    width: 290px;
    transition: 0.3s ease;
  }
  #contact form input:focus{
    outline:none;
  }
  #contact .submit_btn input{
    width: 150px;
    padding: 5px;
    background-color: #a4842d;
    border: none;
    color: white;
    letter-spacing: 2px;
    transition: 0.3s ease;
  }
  #contact .submit_btn input:hover{
    background-color: #8e6f1c
  }
  #contact .social-icons img{
      height:25px;
  }
  #contact .social-icons img:hover{
    cursor: pointer;
  }
  #contact .contact_number{
     text-align: left;
     margin-left: 12.3%;
  }
  #contact .address{
    margin-bottom: 0;
  }
  #contact .contact_warning{
    margin-bottom: 0;
    color: red;
    font-size: 0.9rem;
  }
  .lh-cust{
    padding-top: 0 !important;
    line-height: 25px;
  }
  .footer_logo{
        text-align: left;
  }
  .footer{
    margin-top: 6%;
    font-size: 0.75rem;
  }
  @media (max-width: 1200px) { 
      #contact form input{
        width: 180px;
        transition: 0.3s ease;
      }
      .carousel-caption h1{
        font-size: 65px;
      }
      #contact .contact_number{
        text-align: left;
        margin-left: 4.8%;
      } 
      .soundon {
          right:3%;
          top:0%;
      }
      .soundoff {
          right:3%;
          top:0%;
      }
  }
  @media (max-width: 1050px) { 
      .carousel-caption h1{
        font-size: 55px;
      }
      .sub-title, #contact h4{
         font-size: 1.5rem;
      }
      h4.sub-title{
        font-size: 1.1rem;
      }
      .elevation1{
        width: 28%;
      }
  }
  @media (max-width: 991px){
      #contact h5 {
         font-size: 0.85rem;
      }
      #contact label {
       font-size: 0.75rem;
       letter-spacing: 3px;
       color: white;
       margin-bottom: 0.8rem;
      }
      #contact form input {
          width: 160px;
      }
      #contact .submit_btn input{
        font-size: 14px;
        width: 120px;
      }
      #contact .contact_address h5{
        font-size: 0.75rem;
      }
      #contact .contact_number{
        text-align: left;
        margin-left: 3.5%;
      } 
      #contact .social-icons img{
         height: 20px;
      }
      .soundon {
          right:4%;
          top:4%;
      }
      .soundoff {
          right:4%;
          top:4%;
      }
  }
  @media (max-width: 850px) { 
      .carousel-caption h1{
        font-size: 45px;
      }
      h3.sub-title, #contact h4{
         font-size: 1.3rem;
         letter-spacing: 7px;
      }
      h4.sub-title{
        font-size: 1rem;
      }
      #contact h5{
        letter-spacing: 2px;
      }
      #contact .contact_number{
        text-align: left;
        margin-left: 8%;
      } 
/*      #contact h5, .footer{
        font-size: 0.95rem;
      }*/
  }
  @media (max-width: 767px) { 
      .carousel-caption h1{
        font-size: 36px;
      }
/*      #contact h5{
        letter-spacing: 1px;
      }*/
/*      #contact h5, .footer{
        font-size: 0.9rem;
      }*/
      .margin-custom{
        margin-top:15%;
        margin-bottom: -1.5%;
     }
     #contact .contact_info, .contact_address .address_row{
       flex-direction: column;
     }
     #contact .ml-cust{
       padding-left: 17%;
       margin-top: 5%;
     }
     .ls-cust{
        margin-bottom: 5%;
        line-height: 25px;
     }
     #contact .submit_left{
       display: none;
     }
     #contact .submit{
      margin-left: -11%;
      margin-top: 2%;
      text-align: center !important;
     }
     .contact_address{
      margin-top: 8%;
     }
     #contact .contact_number {
        text-align: center;
        margin-left: 0%;
      }
      #contact hr{
        margin: -2% auto 5% auto;
      }
      .footer_logo, .footer_address, .social-icons{
        justify-content: center;
        margin: 0 auto 5% auto;
     }
      .soundon {
          right:4%;
          top:5%;
      }
      .soundoff {
          right:4%;
          top:5%;
      }
  }  
  @media (max-width: 620px) { 
      .carousel-caption h1{
        font-size: 30px;
      }
      h3.sub-title, #contact h4{
         font-size: 1.2rem;
         letter-spacing: 7px;
      }
      .soundon {
          right:4%;
          top:9%;
      }
      .soundoff {
          right:4%;
          top:9%;
      }
    }
  @media (max-width: 546px) { 
      .carousel-caption h1{
        font-size: 30px;
        letter-spacing: 5px;
      }
      h3.sub-title, #contact h4{
         font-size: 1.1rem;
         letter-spacing: 5px;
      }
      h4.sub-title{
        font-size: 0.8rem;
      }
      #floor_plan button{
        width: 120px;
        font-size: 0.8rem;
      }
      #contact h5, .footer, #contact label{
        font-size: 0.75rem;
      }
      #contact form input {
        width: 130px;
      }
      .soundon {
          right:4%;
          top:13%;
      }
      .soundoff {
          right:4%;
          top:13%;
      }
  }
  @media (max-width: 465px) { 
      .carousel-caption h1{
        font-size: 27px;
        letter-spacing: 5px;
      }
      h3.sub-title{
         font-size: 1rem;
         letter-spacing: 4px;
      }
      #contact h4{
        font-size: 0.8rem;
      }
      h4.sub-title{
        font-size: 0.7rem;
      }
      .elevation1{
        width: 30%;
      }
      .furniture{
        padding: 8% 0;
      }
      #contact h5, .footer{
        font-size: 0.6rem;
        letter-spacing: 2px;
      }
      #contact .contact_info h5,#contact .contact_info label, #contact .contact_info input{
        font-size: 0.55rem;
      }
      #contact .contact_info label{
        margin-bottom: 0.4rem;
      }
      #contact .submit_btn input {
        width: 80px;
      }
      .footer{
        font-size: 0.6rem;
      }
      .margin-custom{
        margin-top:20%;
        margin-bottom: -2%;
     }
  }
  @media (max-width: 415px){
      .margin-custom{
        margin-top:24%;
        margin-bottom: -2%;
     }
     #contact .ml-cust {
        padding-left: 11%;
        margin-top: 5%;
    }
    #contact .submit {
      margin-left: -5%;
    }
  }
  @media (max-width: 375px) { 
      .carousel-caption h1{
        font-size: 25px;
        letter-spacing: 5px;
      }
      h3.sub-title, #contact h4{
         font-size: 0.9rem;
         letter-spacing: 3px;
      }
      h4.sub-title{
        font-size: 0.7rem;
      }
      #floor_plan button{
        width: 100px;
        font-size: 0.7rem;
      }
      #contact h5, .footer{
        font-size: 0.8rem;
        letter-spacing: 1px;
      }
      .footer{
        font-size: 0.6rem;
      }
      .soundon {
          right:5%;
          top:14%;
      }
      .soundoff {
          right:5%;
          top:14%;
      }
  }
  @media (max-width: 320px) { 
      .carousel-caption h1{
        font-size: 25px;
        letter-spacing: 3px;
      }
      h3.sub-title, #contact h4{
         font-size: 0.8rem;
         letter-spacing: 2px;
      }
      h4.sub-title{
        font-size: 0.6rem;
      }
      #contact h5, .footer{
        font-size: 0.7rem;
        letter-spacing: 1px;
      }
      .footer{
        font-size: 0.5rem;
      }
      #contact .ml-cust {
          padding-left: 5%;
          margin-top: 5%;
      }
      #contact .submit {
          margin-left: 0%;
      }
      .soundon {
          right:5%;
          top:18%;
      }
      .soundoff {
          right:5%;
          top:18%;
      }
  }
  @media (min-width: 768px){
      .contact_left{
        padding-right: 3% !important;
      }
      .contact_right{
        padding-left: 3% !important;
      }
  }
  @media (min-width: 991px){
    .navbar-dark .navbar-nav .nav-link{
      padding-bottom: 0;
    }
    .padding-none{
      padding: 0 !important;
    }
    #contact .social-icons .mr-2{
      margin-right: 0.8rem !important;
    }
  }
  @media (min-width: 991px) and (max-width: 1100px){
    .padding-cust{
       padding-left: 5% !important;
    }
  }
  @media (min-width: 1200px) and (max-width: 1300px){
    .padding-cust{
       padding-left: 5% !important;
    }
  }
  @media (min-width:1200px){
    .footer_logo{
      margin-right: -3%;
    }
    .footer_address{
       margin-right: 2%;
    }
  }
</style>
